import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "style"];
import React from 'react';
import { withI18n } from '@cainiaofe/cn-i18n';
import cx from 'classnames';
import WrapCascaderSelect from "./wrap-cascader-select";
import locale from "../locale";
import "./index.scss";
var View = function View(props) {
  var className = props.className,
    style = props.style,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('cn-address-m', className),
    style: style
  }, /*#__PURE__*/React.createElement(WrapCascaderSelect, otherProps));
};
var CnAddressM = withI18n(View, {
  locale: locale
});
CnAddressM.displayName = 'CnAddressM';
CnAddressM.defaultProps = {
  dataLanguage: 'local',
  iso: 'CN',
  includeList: [],
  excludeList: [],
  inlandOnly: false,
  showDisabledDivision: false,
  maxLevel: 5
};
export { CnAddressM };